import React from 'react';

export default () => (
  <div className="Subscribe">

    <div className="Heading">
      Subscribe now to get our<br/>Latest & Greatest Offers & Discounts
    </div>

    <div className="Description">
      Be the first to receive updates, offers & Vouchers.
    </div>

    <form className="Newsletter">
      <input type="email" placeholder='Enter Your Email Address'/>
      <input type="submit" value='SUBMIT'/>
    </form>

  </div>
)
